import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { clearAdminToken } from '../lib/api';

const navItems = [
  { path: '/', label: 'Dashboard', end: true },
  { path: '/liveops', label: 'Live Ops' },
  { path: '/cosmetics', label: 'Cosmetics' },
  { path: '/bundles', label: 'Bundles' },
  { path: '/mascot-dialogs', label: 'Mascot Dialogs' },
  { path: '/users', label: 'Users' },
  { path: '/operations', label: 'Operations' },
];

export default function Layout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAdminToken();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-800 bg-gray-900 px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-2xl">🍴</span>
          <h1 className="text-lg font-semibold">EatEmAll Admin</h1>
        </div>
        <button
          onClick={handleLogout}
          className="text-sm text-gray-400 hover:text-gray-200 transition"
        >
          Logout
        </button>
      </header>

      <div className="flex flex-1">
        {/* Sidebar */}
        <nav className="w-56 border-r border-gray-800 bg-gray-900 p-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `block px-3 py-2 rounded text-sm transition ${
                  isActive
                    ? 'bg-brand-600 text-white font-medium'
                    : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Main content */}
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
